import { combineReducers } from "redux";

import ViewReducer from "./viewReducer";
import StudyInfoReducer from "./studyInfoReducer";
import availableStudiesReducer from "./availableStudiesReducer";
import availableParticipantsReducer from "./availableParticipantsReducer";
import availableProtocolsReducer from "./availableProtocolsReducer";
import protocolReducer from "./protocolReducer.js";
import LocationsReducer from "./locationsReducer";
import SamplesReducer from "./samplesReducer";
import DeviceReducer from "./deviceReducer";
import UtilityReducer from "./utilityReducer.js";
import UserInfoReducer from "./userInfoReducer.js";

const rootReducer = combineReducers({
  view: ViewReducer,
  userInfo: UserInfoReducer,
  availableStudies: availableStudiesReducer,
  availableParticipants: availableParticipantsReducer,
  availableProtocols: availableProtocolsReducer,
  protocol: protocolReducer,
  studyInfo: StudyInfoReducer,
  locations: LocationsReducer,
  samples: SamplesReducer,
  device: DeviceReducer,
  utility: UtilityReducer,
});

export default rootReducer;
